import { render, staticRenderFns } from "./TwentyTable.vue?vue&type=template&id=9e08e6b2&"
import script from "./TwentyTable.vue?vue&type=script&lang=js&"
export * from "./TwentyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports